import React, { useContext, useEffect, useState, useRef } from "react";
import QuizzWidgetQuestion from "../components/QuizzWidgetQuestion";
import { BlendAppQuizzDataContext } from "../contexts/blendAppQuizzData-context";
import { getQuizz, postQuizz } from "../services/quizzWidgetAppService";
import QuizzWidgetResults from "../components/QuizzWidgetResults";

let backBtnText, nextBtnText, backToQuizzText, seeResultsText;

const QuizzWidgetAppLayoutContainer = () => {
    const [blendAppQuizzData, dispatchToBlendAppQuizzData] = useContext(BlendAppQuizzDataContext);
    const [quizz, setQuizz] = useState([]);
    const [activeQuizzItemIndex, setActiveQuizzItemIndex] = useState(0);
    const [selectedOptionId, setSelectedOptionId] = useState(null);
    const [isFinished, setIsFinished] = useState(false);
    const [result, setResult] = useState(null);
    const quizzWidgetRef = useRef(null);
    

    const fetchData = async () => {
        const quizId = document.getElementById('quizzWidgetAppId').value;
        const quizCulture = document.getElementById('quizzWidgetAppCulture').value;
        const {quizz, nextButtonText, previousBtnText, backToQuizzBtnText, seeResultsBtnText} = await getQuizz(quizId, quizCulture);
        backBtnText = previousBtnText;
        nextBtnText = nextButtonText;
        backToQuizzText = backToQuizzBtnText;
        seeResultsText = seeResultsBtnText;
        setQuizz(quizz);
    };

    const postData = async () => {
        const quizId = document.getElementById('quizzWidgetAppId').value;
        const quizCulture = document.getElementById('quizzWidgetAppCulture').value;
        const result = await postQuizz(quizId, quizCulture, {answers: blendAppQuizzData});
        setResult(result);
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (isFinished) postData();
    }, [isFinished]);

    useEffect(() => {
        const activeQuizzDataItem = blendAppQuizzData.find(
            (quizzDataItem) => quizzDataItem.questionId === quizz[activeQuizzItemIndex].id
        );
        const selectedOptionId = activeQuizzDataItem ? activeQuizzDataItem.answerId : null;
        setSelectedOptionId(selectedOptionId);
    }, [activeQuizzItemIndex, blendAppQuizzData]);

    const prev = () => {
        setActiveQuizzItemIndex(activeQuizzItemIndex - 1);
        if (window.matchMedia('(max-width: 639px)').matches) {
            window.scrollTo(0, quizzWidgetRef.current.offsetTop - 64);
        }
    }

    const goBackToQuizz = () => {
        setIsFinished(false)
        setActiveQuizzItemIndex(quizz.length - 1);
        if (window.matchMedia('(max-width: 639px)').matches) {
            window.scrollTo(0, quizzWidgetRef.current.offsetTop - 64);
        }
    }

    const next = () => {
        setActiveQuizzItemIndex(activeQuizzItemIndex + 1)
        if (window.matchMedia('(max-width: 639px)').matches) {
            window.scrollTo(0, quizzWidgetRef.current.offsetTop - 64);
        }
    }

    const onOptionSelect = (optionId, redirect, redirectionUrl) => {
        if (redirect) {
            window.location.href = redirectionUrl
            return;
        }
        setSelectedOptionId(optionId);
        dispatchToBlendAppQuizzData({
            type: 'ADD_ANSWER',
            payload: {
                questionId: quizz[activeQuizzItemIndex].id,
                answerId: optionId
            }
        });

        // logic to switch to next question on answer click
        if (activeQuizzItemIndex < quizz.length - 1) {
            setActiveQuizzItemIndex(activeQuizzItemIndex + 1)
            if (window.matchMedia('(max-width: 639px)').matches) {
                window.scrollTo(0, quizzWidgetRef.current.offsetTop - 64);
            }
        } else {
            setIsFinished(true)
        }
    }

    if (isFinished && result) {
        return (
            <QuizzWidgetResults result={result} goBackToQuizz={goBackToQuizz} backToQuizzText={backToQuizzText} />
        )
    }
    
    return (
        <div className="bg-gray-brown quizz-widget" ref={quizzWidgetRef}>
            <div className="container">
                <div className="py-40 2xs:pt-24">
                    <div className="relative mt-8 h-40 3xs:pb-28">
                        <div className={`h-full flex items-center ${activeQuizzItemIndex === 0 && !isFinished ? "justify-end" : "justify-between"}`}>
                            {activeQuizzItemIndex !== 0 && 
                                <button className="link link--primary link--arrow-left outline-none focus:shadow-outline focus:rounded" onClick={prev}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.02 8.82">
                                        <path d="M4.15,8.53A1,1,0,0,0,5.56,7.11L3.85,5.41H17a1,1,0,0,0,0-2H3.85l1.71-1.7A1,1,0,0,0,5.56.3,1,1,0,0,0,4.85,0a1,1,0,0,0-.7.29L0,4.41,4.15,8.53Z"></path>
                                    </svg>
                                    <span>{backBtnText}</span>
                                </button>
                            }
                            <div className="hidden absolute centered-x sm:flex justify-center items-start text-14 mt-6 h-22 3xs:top-32">
                                <span className="text-24 text-primary font-bold leading-14">
                                    {activeQuizzItemIndex + 1 > 9 ? activeQuizzItemIndex + 1 : `0${activeQuizzItemIndex + 1}` }
                                </span>
                                /
                                {quizz.length > 9 ? quizz.length : `0${quizz.length}` }
                            </div>
                            <div className="sm:hidden flex absolute centered-x">
                                {quizz.map((item, index) => 
                                    <div key={index} className={`mx-4 w-40 h-8 rounded-4${index <= activeQuizzItemIndex ? "  bg-primary" : " bg-gray-brown-dark"}`} ></div>
                                )}
                            </div>
                            {(selectedOptionId && activeQuizzItemIndex <= blendAppQuizzData.length - 1 && activeQuizzItemIndex < quizz.length - 1)  &&
                                <button className={`link link--primary link--arrow-right outline-none focus:shadow-outline focus:rounded"${!selectedOptionId ? " disabled" : ""}`} onClick={next}>
                                    <span>{nextBtnText}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.02 8.82">
                                        <path xmlns="http://www.w3.org/2000/svg" d="M13.86.29a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.41l1.71,1.7H1a1,1,0,0,0,0,2H14.16l-1.71,1.7a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.7-.29L18,4.41Z"></path>
                                    </svg>
                                </button>
                            }
                            {(activeQuizzItemIndex === quizz.length - 1 && result) &&
                                <button className={`link link--primary link--arrow-right outline-none focus:shadow-outline focus:rounded"${!selectedOptionId ? " disabled" : ""}`} onClick={() => setIsFinished(true)}>
                                    <span>{seeResultsText}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.02 8.82">
                                        <path xmlns="http://www.w3.org/2000/svg" d="M13.86.29a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.41l1.71,1.7H1a1,1,0,0,0,0,2H14.16l-1.71,1.7a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.7-.29L18,4.41Z"></path>
                                    </svg>
                                </button>
                            }
                        </div>
                    </div>
                    {quizz.map((quizzItem, index) => index === activeQuizzItemIndex &&
                        <QuizzWidgetQuestion 
                            key={quizzItem.id} 
                            {...quizzItem} 
                            onOptionSelect={onOptionSelect}
                            selectedOptionId={selectedOptionId} 
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuizzWidgetAppLayoutContainer;
